const fallbackOnboardingSteps = {
  object: 'object',
  data: {
    entities: [
      {
        name: 'email',
        type: 'email',
        properties: {
          title: 'Sign up to get started!',
          subtitle: 'Let’s get you signed up.',
          showSkipButton: false,
          showBackButton: false,
        },
      },
      {
        name: 'name',
        type: 'name',
        properties: {
          title: "What's your name?",
          subtitle: 'Using your real name makes it easier for friends to recognize you.',
          showSkipButton: false,
          showBackButton: false,
        },
      },
      // {
      //   name: 'phone',
      //   type: 'phone',
      //   properties: {
      //     title: 'What’s your phone number?',
      //     subtitle: 'Using your phone number helps friends and family find you on PRAY.COM',
      //     showSkipButton: false,
      //     showBackButton: false,
      //   },
      // },
      {
        name: 'pricing_paywall',
        type: 'pricing_paywall',
        properties: {
          title: 'Choose your plan',
          subtitle: "Choose the plan that fits your ministry's size and vision.",
          showSkipButton: false,
          showBackButton: false,
        },
      },
      {
        name: 'ministry_info',
        type: 'ministry_info',
        properties: {
          title: 'Tell us about yourself and your ministry',
          subtitle:
            'Tell us about your role and ministry so we can make PRAY STUDIO work perfectly for you and your community.',
          showSkipButton: false,
          showBackButton: false,
        },
      },
    ],
  },
};

export default fallbackOnboardingSteps;
